import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Difference',
  name: 'difference',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Description',
      name: 'content',
      type: 'text',
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
    defineField({
      title: 'Icon',
      name: 'icon',
      type: 'string',
      options: {
        list: [
          { title: 'None', value: '' },
          { title: 'Buys', value: 'buys' },
          { title: 'Engineering', value: 'engineering' },
          { title: 'Facts', value: 'facts' },
          { title: 'Replacement', value: 'replacement' },
          { title: 'Scale', value: 'scale' },
          { title: 'Warranty', value: 'warranty' },
        ],
      },
      initialValue: '',
    }),
  ],
})